import { render, staticRenderFns } from "./handlePreviewSwiper.vue?vue&type=template&id=40da0ed0&scoped=true"
import script from "./handlePreviewSwiper.vue?vue&type=script&lang=js"
export * from "./handlePreviewSwiper.vue?vue&type=script&lang=js"
import style0 from "./handlePreviewSwiper.vue?vue&type=style&index=0&id=40da0ed0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40da0ed0",
  null
  
)

export default component.exports